import React, { useEffect, useState } from 'react'
import ChartApi from '../../charts/chart.api';

export default function VisibilityDataTable() {
      const tabs = [
      {
        name : 'Shipped On-Board',
        headers : [
            {
                name : 'Agraga Booking Number',
                key : 'agraga_booking_#'
            },
            {
                name : 'ETD @ POL',
                key : 'etd_at_pol'
            },

        ]
      } ,
       {
        name : 'Transshipment Arrival',
        headers : [
            {
                name : 'Agraga Booking Number',
                key : 'agraga_booking_#'
            },
            {
                name : 'ETA Transshipment 1',
                key : 'ts1_arrival'
            },
             {
                name : 'ETA Transshipment 2',
                key : 'ts2_arrival'
            },
             {
                name : 'ETA Transshipment 3',
                key : 'ts3_arrival'
            },

        ]
      } ,
       {
        name : 'Transshipment Departure',
        headers : [
            {
                name : 'Agraga Booking Number',
                key : 'agraga_booking_#'
            },
            {
                name : 'ETD Transshipment 1',
                key : 'ts1_departure'
            },
             {
                name : 'ETD Transshipment 2',
                key : 'ts2_departure'
            },
             {
                name : 'ETD Transshipment 3',
                key : 'ts3_departure'
            },

        ]
      } ,
       {
        name : 'Discharge',
        headers : [
            {
                name : 'Agraga Booking Number',
                key : 'agraga_booking_#'
            },
            {
                name : 'ETA @ FPOD ',
                key : 'eta_fpod'
            },
             {
                name : 'ETA @ POD',
                key : 'eta_at_pod'
            },
           
        ]
      } ,
        {
        name : 'Container Pick-Up',
        headers : [
            {
                name : 'Agraga Booking Number',
                key : 'agraga_booking_#'
            },
            {
                name : 'ATA @ FPOD',
                key : 'gatein_fpod'
            },
                     
        ]
      } ,
         {
        name : 'Empty Return',
        headers : [
            {
                name : 'Agraga Booking Number',
                key : 'agraga_booking_#'
            },
            {
                name : 'Container Pick-up Date at FPOD',
                key : 'containerlist[0].gatein_fpod'
            },
                     
        ]
      } ,
       {
        name : 'Closure',
        headers : [
            {
                name : 'Agraga Booking Number',
                key : ''
            },
            {
                name : 'My Action',
                key : ''
            },
                     
        ]
      } ,
    // 'Shipped On-Board Pending',
    // 'Transhipment Arrival',
    // 'Transhipment Departure',
    // 'Discharge',
    // 'Container Pick-up',
    // 'Empty Return',
    // 'Closure',
  ];

    const [selectedTab, setSelectedTab] = useState(tabs[0].name);
    const [data, setData] = useState({
            'Shipped On-Board' : [],
            'Transshipment Arrival' : [],
            'Transshipment Departure' : [],
             'Discharge' : [],
             'Container Pick-Up' : [] ,
             'Empty Return' : [],
             'Closure' : []
        });

    useEffect(()=> {
       ChartApi.getVisibilityDashData((data)=>setData(data.Data)) 
    },[])
  

  const selectedTabData = () => {
    return tabs.filter((tab)=>tab.name === selectedTab)[0]
  }

  return (
    <div>
     {/* <div className='visibilityDashTopCon'>
     <button >Shipment On-Board Pending</button>
     <button >Transhipment Arrival</button>
     <button >Transhipment Departure</button>
     <button >Discharge</button>
     <button >Container Pick-up</button>
     <button >Empty Return</button>
     <button >Closure</button>

     </div> */}

       <div className='visibilityDashTopCon' style={{ display: 'flex', gap: '5px' }}>
      {tabs?.map((tab) => (
        <button
          key={tab.name}
          onClick={() => setSelectedTab(tab.name)}
          style={{
            border: 'none',
            borderRadius: '4px',
            backgroundColor: selectedTab === tab.name ? '#FFA500' : '#FFFFFF',
            color: selectedTab === tab.name ? 'white' : '#333',
            fontWeight: selectedTab === tab.name ? 'bold' : 'normal',
            cursor: 'pointer',
          }}
        >
          {tab.name}
        </button>
      ))}
    </div>
    <div className='table-wrapper'>
    <table className='custom-table'>
        <thead>
                  <tr>
                  {selectedTabData()?.headers?.map((x,i) => {
                    return <th>{x.name}</th>
                  })

                  }
                      {/* <th>Agraga Booking number</th>
                      <th>ETA Transhipment 1</th>
                      <th>ETA Transhipment 2</th>
                      <th>ETA Transhipment 3</th> */}
                  </tr>
        </thead>
        <tbody>
                           {
                            (data && data[selectedTabData().name] || [])?.map((r,z) => {
                                  return <tr>
                                      {(selectedTabData().headers || [])?.map((x, i) => {
                                        let keyyy = x.key
                                        return <td>{r[x.key]}</td>
                                      })
                                      }
                               
                                </tr>
                            })
                          }
        </tbody>
    </table>
    </div>
      
    </div>
  )
}


